export const HistoryHelper = function() {
  // Private data
  const ChangesHistory = [];
  let UndoHistory = [];

  // Expose public API
  return {
    addChange: function(changeValue, links) {
      //Add the Change to the beginning of the List, like a Stack
      ChangesHistory.unshift({
        value: changeValue,
        date: new Date(),
        links: links ? links : []
      });

      //Reset the UndoHistory, it makes no sense when we add a new Change, that we can make it redo
      if (this.checkUndoHistory()) {
        UndoHistory = [];
      }
    },
    undo: function() {
      if (this.checkChangesHistory()) {
        //Get & Delete first Value from ChangesHistory
        const undoValue = ChangesHistory.shift();

        //Add the first Value from ChangeList to UndoList, is needed for redo
        UndoHistory.unshift(undoValue);

        return {
          newValue: ChangesHistory[0],
          oldValue: undoValue 
        } 
      }
    },
    redo: function() {
      //Get & Delete first Value from UndoHistory
      if (this.checkUndoHistory()) {
        return UndoHistory.shift();
      }
    },
    getChangesHistory: function() {
      //Get Changes History for testing purposes
      return ChangesHistory;
    },
    getUndoHistory: function() {
      //Get Undo History for testing purposes
      return UndoHistory;
    },
    checkUndoHistory: function() {
      if (UndoHistory && UndoHistory.length) {
        return true;
      } else {
        return false;
      }
    },
    checkChangesForLinks: function() {
      if(ChangesHistory[0].links && ChangesHistory[0].links.length > 0){
        return true;
      }
      else{
        return false;
      }
    },
    checkChangesHistory: function() {
      if (ChangesHistory && ChangesHistory.length > 1) {
        return true;
      } else {
        return false;
      }
    }
  };
};